import { useContext } from 'react';
import QuizrrStampLight from '../../../../../../apps/frontend/public/icons/quizrrStampLight.svg';
import QuizrrStampDark from '../../../../../../apps/frontend/public/icons/quizrrStampDark.svg';
import { ThemeContext } from '../../../../../../apps/frontend/src/context/ThemeStore';

export default function CombinedOverallScoreCard({ overallData, isPercentileAvailable, paperData }) {
  const { isDarkTheme } = useContext(ThemeContext);

  const getPaperName = (title = '') => {
    const match = title.match(/Paper\s*\d+/i);
    return match ? match[0] : title;
  };

  return (
    <div
      className={`relative w-full flex flex-1 ${
        isPercentileAvailable ? 'flex-col h-[258px]' : 'flex-col md:flex-row'
      } rounded-xl border border-[var(--q3-stroke-light)] bg-gradient-to-t from-[var(--q3-surface-dim)] to-[var(--q3-surface-default)]`}
    >
      {/* Blue Highlight Bar */}
      <div
        className={`absolute left-0 ${
          isPercentileAvailable ? 'top-1/4 h-1/4' : 'top-1/4 h-1/4 md:h-1/2'
        } w-[6px] bg-[var(--q3-blue-normal)] rounded-r-full`}
      />

      {/* Quizrr Stamp */}
      <div className="absolute top-0 right-0">
        <img src={isDarkTheme ? QuizrrStampDark : QuizrrStampLight} alt="quizrr stamp" />
      </div>

      {/* Score Section */}
      <div className={`flex flex-col ${isPercentileAvailable ? 'ml-6 mt-5 mb-4' : 'ml-6 mt-5 mb-2 md:mb-8'}`}>
        <p className="text-[var(--q3-neutral-default)] text-[16px] font-bold">Overall Score</p>
        <div className="flex flex-row items-end mt-3">
          <p className="md:text-[90px] text-5xl text-[var(--q3-blue-normal)] font-black leading-none">
            {overallData?.markScored}
          </p>
          <p className="text-xl md:text-3xl text-[var(--q3-neutral-light)] pb-2">/{overallData?.totalScore}</p>
        </div>

        {isPercentileAvailable && Array.isArray(paperData) && paperData.length > 0 && (
          <div className="flex flex-row flex-wrap mt-10 gap-x-6 gap-y-2">
            {Object?.values(paperData)?.map((item) => (
              <div className="flex flex-col gap-1 font-medium" key={item?.title}>
                <p className="text-[var(--q3-neutral-light)] text-[10px] md:text-xs xl:text-sm">
                  {getPaperName(item?.title)} Score
                </p>
                <div className="flex flex-row items-center">
                  <p className="text-sm md:text-xl xl:text-2xl font-bold text-[var(--q3-neutral-default)]">
                    {item?.markScored}
                  </p>
                  <p className="text-[var(--q3-neutral-light)] text-[10px] md:text-xs xl:text-sm ml-[2px]">
                    /{item?.totalScore}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {!isPercentileAvailable && Array.isArray(paperData) && paperData.length > 0 && (
        <div className="flex flex-row flex-wrap ml-6 md:ml-16 mt-5 mb-4 md:mb-10 items-end gap-x-6 gap-y-2">
          {Object.values(paperData).map((item) => (
            <div className="flex flex-col gap-1 font-medium" key={item?.title}>
              <div className="flex flex-row items-center">
                <p className="text-sm md:text-xl xl:text-2xl font-bold text-[var(--q3-neutral-default)]">
                  {item?.markScored}
                </p>
                <p className="text-[var(--q3-neutral-light)] text-[10px] md:text-xs xl:text-sm ml-[2px]">
                  /{item?.totalScore}
                </p>
              </div>
              <p className="text-[var(--q3-neutral-light)] text-[10px] md:text-xs xl:text-sm">
                {getPaperName(item?.title)} Score
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
